
import { useQuery } from "react-query"
import DataService from '../../config/DataServices'






const { postRequest,getRequest} = DataService()


export const useGetDashBoard = () => {

    return useQuery({
        queryKey: ["get-dashboard"],
        queryFn: () => {
            return getRequest(`user/dashboard`)
        }
    })
}

export const useGetRefferalCount = () => {

    return useQuery({
        queryKey: ["get-referral"],
        queryFn: () => {
            return getRequest(`user/referral-count`)
        }
    })
}

export const useGetSales = () => {

    return useQuery({
        queryKey: ["get-sales"],
        queryFn: () => {
            return getRequest(`user/sales-progress`)
        }
    })
}

export const useGetPreSales = () => {

    return useQuery({
        queryKey: ["get-presales"],
        queryFn: () => {
            return getRequest(`user/get_presale`)
        }
    })
}